/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_ExpectedInputs */

const en_audit_expected = /** @type {(inputs: Audit_ExpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected`)
};

const es_audit_expected = /** @type {(inputs: Audit_ExpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperado`)
};

/**
* | output |
* | --- |
* | "Expected" |
*
* @param {Audit_ExpectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_expected = /** @type {((inputs?: Audit_ExpectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_ExpectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_expected(inputs)
	return es_audit_expected(inputs)
});